export default [
    // Example
    // {
    //     name: 'wallTexture',
    //     type: 'texture',
    //     path: 'textures/wall.jpg'
    // }
    // {
    //     name: 'damagedHelmet',
    //     type: 'gltfModel',
    //     path: 'models/DamagedHelmet/glTF/DamagedHelmet.gltf'
    // },
    // {
    //     name: 'rocket',
    //     type: 'gltfModel',
    //     path: 'models/Rocket/glTF/Rocket.gltf'
    // },
    {
        name: 'f1',
        type: 'gltfModel',
        path: 'models/F1/glTF/F1.gltf'
    },
]